import { Component, AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import * as maplibregl from 'maplibre-gl';
import { MapService } from '../../services/map-service/map.service';
import { InformationComponent } from '../information-container/information.component';
import { GeneralPointJson, LimitJson,pathJson, PointInfoProps, PointJson, SubapJson } from '../../interface/map.interfaces';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-map',
  standalone: true,
  imports: [InformationComponent,CommonModule],
  templateUrl: './map.component.html',
  styleUrl: './map.component.scss',
})
export class MapComponent  implements AfterViewInit, OnInit, OnDestroy {
  private map!: maplibregl.Map;
  isSubapVisible: boolean = false;
  isPMetroVisible: boolean = false;
  isPOnibusVisible: boolean = false;
  isPTremVisible: boolean = false;
  information: PointInfoProps = {
    rp_cod: "",
    rp: "",
    ra_cod: 0,
    ra: "",
    cod_bairro: 0,
    bairro: "",
    favela: "",
    morfologia: "",
    cat_entrada: "",
    tipo_entrada: "",
    grau_entrada: "",
  };

  selectedFavela = "";
  pontos:PointJson[] = [];
  limite:LimitJson[] =[];
  caminhos:pathJson[] =[];
  subap:SubapJson[] =[];
  pOnibus:GeneralPointJson[] =[];
  pMetro:GeneralPointJson[] =[];
  pTrem:GeneralPointJson[] =[];
  tBrt:pathJson[] =[];
  tTrans:pathJson[] =[];
  tTrem:pathJson[] =[];
  tMetro:pathJson[] =[];

  infoOpen: boolean = false;

  constructor(private mapService: MapService) {

  }

  async ngOnInit(){
  }


   async ngAfterViewInit(){
    await this.fetchAllData().then(() => {
      this.loadMap();
    })
    }
  loadMap(): void {
    this.map = new maplibregl.Map({
      container: 'map',
      style: 'https://api.maptiler.com/maps/streets-v2/style.json?key=fd45uZDZq0cTCdePwZBo',
      center: [-43.30817303243969, -22.856809245004662],
      zoom: 11,
    });


    this.map.addControl(
      new maplibregl.ScaleControl({
        maxWidth: 100,
        unit: "metric",
      }),
      "bottom-left"
    );

    this.map.on("load",  () => {
       this.map!.addSource("points", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: this.pontos,
        },
      });

      this.map!.addSource("caminhos", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: this.caminhos,
        },
      });

      this.map!.addSource("limite", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: this.limite,
        },
      });

      this.map!.addSource("subap", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: this.subap,
        },
      });

      this.map!.addSource("pOnibus", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: this.pOnibus,
        },
      });

      this.map!.addSource("pMetro", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: this.pMetro,
        },
      });

      this.map!.addSource("pTrem", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: this.pTrem,
        },
      });

      this.map!.addSource("tBrt", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: this.tBrt,
        },
      });

      this.map!.addSource("tTrans", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: this.tTrans,
        },
      });

      this.map!.addSource("tTtrem", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: this.tTrem,
        },
      });

      this.map!.addSource("tMetro", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: this.tMetro,
        },
      });

      this.map!.addLayer({
        id: "limite-layer",
        type: "fill",
        source: "limite",
        layout: {},
        paint: {
          "fill-color": [
            "match",
            ["get", "morfologia"],
            "Enclave",
            "#00f0f0",
            "Linha",
            "#f900f9",
            "Malha",
            "#a7a700",
            "Quadra",
            "#009933",
            /* default */ "#808080",
          ],
          "fill-opacity": 0.2,
          "fill-outline-color": "#000",
        },
      });

      this.map!.addLayer({
        id: "limite-outline-layer",
        type: "line",
        source: "limite",
        layout: {},
        paint: {
          "line-color": "#000000",
          "line-width": 1,
          "line-opacity": 1,
        },
      });

      this.map!.addLayer({
        id: "subap-layer",
        type: "fill",
        source: "subap",
        layout: {
          visibility: this.isSubapVisible ? "visible" : "none",
        },
        paint: {
          "fill-color": [
            "match",
            ["get", "cod_rp"],
            "3.1",
            "#dc61a5",
            "3.2",
            "#59d12a",
            "3.3",
            "#484dcb",
            "3.4",
            "#da9b3c",
            "3.5",
            "#79cb9f",
            "3.6",
            "#1fb9e4",
            "3.7",
            "#d5d03d",
            "#b873d5",
          ],
          "fill-opacity": 0.2,
          "fill-outline-color": "#000",
        },
      });

      this.map!.addLayer({
        id: "subap-outline-layer",
        type: "line",
        source: "subap",
        layout: {
          visibility: this.isSubapVisible ? "visible" : "none",
        },
        paint: {
          "line-color": "#000000",
          "line-width": 0.5,
          "line-opacity": 1,
        },
      });

      this.map!.addLayer({
        id: "caminhos-layer",
        type: "line",
        source: "caminhos",
        paint: {
          "line-color": "#dbff10",
          "line-width": 2,
          "line-opacity": 1,
        },
      });

      this.map!.addLayer({
        id: "points-layer",
        type: "circle",
        source: "points",
        filter: ["!", ["has", "point_count"]],
        paint: {
          "circle-color": [
            "match",
            ["get", "cat_entrada"],
            "Acesso",
            "#ff7600",
            "Portal",
            "#cc8899",
            /* default */ "#ff7600",
          ],
          "circle-radius": 5,
        },
      });

      this.map!.addLayer({
        id: "pMetro-layer",
        type: "circle",
        source: "pMetro",
        layout: {
          visibility: this.isPMetroVisible ? "visible" : "none",
        },
        filter: ["!", ["has", "point_count"]],
        paint: {
          "circle-color": "#4ebbee",
          "circle-radius": 5,
        },
      });

     // const busStopImage = await this.map!.loadImage(
       //"../../../assets/bus_stop-icon.png"
     // );

      //console.log(busStopImage)
      //this.map!.addImage("busStop", busStopImage.data);

      // this.map!.addLayer({ //outra opção de imagem para os pontos
      //   id: "pOnibus-layer",
      //   type: "symbol",
      //   source: "pOnibus",
      //   layout: {
      //     visibility: "none",
      //     "icon-image": "busStop",
      //     "icon-size": 0.08,
      //   },
      // });
      this.map!.addLayer({
        id: "pOnibus-layer",
        type: "circle",
        source: "pOnibus",
        layout: {
          visibility: "none",
        },
        paint: {
          "circle-color": "#39d4a6",
          "circle-radius": 4,
        },
      });

      this.map!.addLayer({
        id: "pTrem-layer",
        type: "circle",
        source: "pTrem",
        layout: {
          visibility: "none",
        },
        filter: ["!", ["has", "point_count"]],
        paint: {
          "circle-color": "#d0e76a",
          "circle-radius": 4,
        },
      });

      this.map!.addControl(new maplibregl.NavigationControl(), "top-left");

      this.applyFilter();

      this.map!.setPaintProperty("limite-layer", "fill-opacity", [
        "match",
        ["get", "nome"],
        this.selectedFavela,
        0.8,
        0.2,
      ]);

    });

    this.map.on("click", "points-layer", (e) => {
      if (e.features && e.features.length > 0) {
        const clickedFeature = e.features[0];

        // Porpriedades do ponto clicado
        const properties = clickedFeature.properties;

        /*
        // TODO: Excluir ou modificar este popup
        new maplibregl.Popup()
          .setLngLat(e.lngLat)
          .setHTML(
            `<h3>${properties.bairro}</h3><p>Favela: ${properties.favela}</p>`
          )
          .addTo(this.map!);*/

        const center: [number, number] = [e.lngLat.lng, e.lngLat.lat];
        this.map!.flyTo({
          center: center,
          zoom: 15,
        });

        this.information = {
          rp_cod: properties['rp_cod'],
          rp: properties['rp'],
          ra_cod: properties['ra_cod'],
          ra: properties['ra'],
          cod_bairro: properties['cod_bairro'],
          bairro: properties['bairro'],
          favela: properties['favela'],
          morfologia: properties['morfologia'],
          cat_entrada: properties['cat_entrada'],
          tipo_entrada: properties['tipo_entrada'],
          grau_entrada: properties['grau_entrada'],
        }

        this.selectedFavela = properties['favela'];
        this.infoOpen = true;

  }
});

this.map.on("mouseenter", "points-layer", () => {
  this.map!.getCanvas().style.cursor = "pointer";
});

this.map.on("mouseleave", "points-layer", () => {
  this.map!.getCanvas().style.cursor = "";
});


  }

  ngOnDestroy(): void {
    if (this.map) {
      this.map.remove();
    }
  }

  async fetchAllData() {
    this.pontos = await this.mapService.getPontos();
    this.limite = await this.mapService.getLimite();
    this.caminhos = await this.mapService.getCaminhos();
    this.subap = await this.mapService.getSubap();
    this.pOnibus = await this.mapService.getPontoOnibus();
    this.pMetro = await this.mapService.getEstacaoMetro();
    this.pTrem = await this.mapService.getEstacaoTrem();
    this.tBrt = await this.mapService.getTrajetosBrt();
    this.tTrans = await this.mapService.getTrajetosTrans();
    this.tTrem = await this.mapService.getTrajetosTrem();
    this.tMetro = await this.mapService.getTrajetosMetro();
  }


  applyFilter(filter?:string){

    this.isSubapVisible = filter === 'bairros' ? !this.isSubapVisible : this.isSubapVisible;
    this.isPMetroVisible = filter === 'metro' ? !this.isPMetroVisible : this.isPMetroVisible;
    this.isPOnibusVisible = filter === 'onibus' ? !this.isPOnibusVisible : this.isPOnibusVisible;
    this.isPTremVisible = filter === 'trem' ? !this.isPTremVisible : this.isPTremVisible;

    this.map.setLayoutProperty("subap-layer","visibility", this.isSubapVisible ? "visible" : "none");
    this.map.setLayoutProperty("subap-outline-layer","visibility", this.isSubapVisible ? "visible" : "none");
    this.map.setLayoutProperty("pMetro-layer","visibility", this.isPMetroVisible ? "visible" : "none");
    this.map.setLayoutProperty("pOnibus-layer","visibility", this.isPOnibusVisible ? "visible" : "none");
    this.map.setLayoutProperty("pTrem-layer", "visibility", this.isPTremVisible ? "visible" : "none"
    );
  }

}
